<template>
  <div class="is-height-100p">
    <div @click="open = true">
      <b-icon
        icon="menu">
      </b-icon>
    </div>
    <section>
      <b-sidebar
        type="is-white"
        fullheight
        :right="right"
        :open.sync="open"
      >
        <div class="p-1">
          <div class="level">
            <div class="level-left pl-7">
              <div class="level-item">
                <a @click="open = false">
                  <b-icon custom-class="menu-icon" icon="close">
                  </b-icon>
                </a>
              </div>
              <div class="level-item">
                <a class="pointer" @click="open = false">
                  <img class="menulogo"
                    src="@/assets/images/accueilLogo.svg"
                    alt="Affixe2.0"
                  />
                </a>
              </div>
            </div>
            <div class="level-right"></div>
          </div>
          <b-menu class="mt-10">
            <b-menu-list>
              <b-menu-item
                :label="$t('menu.itemDashbord')"
                tag="a"
                :active="$route.name === 'tableau-de-bord'"
                @click="goTo('tableau-de-bord')">
              </b-menu-item>
            </b-menu-list>
            <b-menu-list>
              <b-menu-item
                class="mt-30"
                :label="$t('menu.itemListeRecom')"
                tag="a"
                :active="$route.name === 'liste-recommendation'"
                @click="goTo('liste-recommendation')">
              </b-menu-item>
            </b-menu-list>
            <b-menu-list>
              <b-menu-item
                class="mt-30"
                :label="$t('menu.itemListeClient')"
                tag="a"
                :active="$route.name === 'liste-client'"
                @click="goTo('liste-client')">
              </b-menu-item>
            </b-menu-list>
          </b-menu>
          <div class="parametres">
            <b-menu-list>
              <b-menu-item :label="$t('menu.itemParametre')"></b-menu-item>
            </b-menu-list>
          </div>
        </div>
      </b-sidebar>
    </section>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const User = createNamespacedHelpers('user');
export default {
 data() {
    return {
      open: false,
      right: false,
    };
  },
  computed: {
    ...User.mapGetters({
      getUserId: 'userId',
    }),
  },
  methods: {
    goToDashbord() {
      this.$router.replace({name: 'tableau-de-bord'});
      this.open = false;
    },
    goTo(name) {
      this.$router.push({name});
      this.open = false;
    }
  },
};
</script>

<style>
.p-1 {
  padding: 1em;
}
</style>
